import styled from "styled-components"

export const PurchaserContainer = styled.div`
display: flex;
/* justify-content: space-between; */
/* flex-flow: row wrap; */
flex-direction:column;
`

export const Purchaser = styled.div`
    display: flex;
    align-items: center;
    margin-top: 1rem;
`
export const DeleteBtn = styled.div`
    margin-right: 10px;
`
export const Image = styled.div`
    margin-right: 10px;
`

export const Details = styled.div`
    display: flex;
    flex-direction: column;
`

export const Name = styled.span`
    font-weight: bold;
    margin-right: 5px;
`
export const LegalHeirName = styled.span`
    font-weight: bold;
    font-size: 12px;
`

export const Mobile = styled.span`

`

export const Email = styled.span`

`

export const LegalHeirContainer = styled.div`
    margin-left: 2rem;
`

export const LegalHeir = styled.div`
display: flex;
    align-items: center;
    margin-top: 1rem;
`